﻿/**
 * Soccer Revolution — Currency Switcher
 * Auto-detects visitor timezone → maps to local currency.
 * Fetches live rates from open.er-api.com (cached 1h in localStorage).
 * Elements with data-cents="<shopify_cents>" or data-gtq="<amount>" are auto-converted.
 */
(function () {
  'use strict';

  var SUPPORTED = ['GTQ', 'USD', 'MXN', 'HNL', 'CRC', 'BZD', 'EUR', 'GBP', 'CAD'];

  var SYMBOLS = {
    GTQ: 'Q', USD: 'US$', MXN: 'MX$', EUR: '€',
    HNL: 'L', BZD: 'BZ$', CRC: '₡', CAD: 'CA$', GBP: '£'
  };

  var NAMES = {
    GTQ: 'Quetzal (GT)',
    USD: 'Dólar (US)',
    MXN: 'Peso mexicano',
    EUR: 'Euro',
    HNL: 'Lempira (HN)',
    BZD: 'Dólar Belice',
    CRC: 'Colón (CR)',
    CAD: 'Dólar canadiense',
    GBP: 'Libra esterlina'
  };

  var TZ_MAP = {
    'America/Guatemala': 'GTQ',
    'America/New_York': 'USD',    'America/Chicago': 'USD',
    'America/Los_Angeles': 'USD', 'America/Denver': 'USD',
    'America/Phoenix': 'USD',     'America/Anchorage': 'USD',
    'Pacific/Honolulu': 'USD',    'America/Detroit': 'USD',
    'America/Indiana/Indianapolis': 'USD',
    'America/Mexico_City': 'MXN', 'America/Monterrey': 'MXN',
    'America/Cancun': 'MXN',      'America/Merida': 'MXN',
    'America/Tijuana': 'MXN',     'America/Chihuahua': 'MXN',
    'America/Hermosillo': 'MXN',  'America/Mazatlan': 'MXN',
    'America/Tegucigalpa': 'HNL',
    'America/Belize': 'BZD',
    'America/Costa_Rica': 'CRC',
    'America/El_Salvador': 'USD', 'America/Managua': 'USD',
    'America/Panama': 'USD',      'America/Caracas': 'USD',
    'America/Bogota': 'USD',      'America/Lima': 'USD',
    'America/Guayaquil': 'USD',
    'Europe/Madrid': 'EUR',       'Europe/Paris': 'EUR',
    'Europe/Berlin': 'EUR',       'Europe/Rome': 'EUR',
    'Europe/Amsterdam': 'EUR',    'Europe/Brussels': 'EUR',
    'Europe/Lisbon': 'EUR',       'Europe/Vienna': 'EUR',
    'Europe/Athens': 'EUR',       'Europe/Helsinki': 'EUR',
    'Europe/Dublin': 'EUR',       'Europe/Warsaw': 'EUR',
    'Europe/Stockholm': 'EUR',    'Europe/Copenhagen': 'EUR',
    'Europe/London': 'GBP',
    'America/Toronto': 'CAD',     'America/Vancouver': 'CAD',
    'America/Winnipeg': 'CAD',    'America/Halifax': 'CAD',
    'America/St_Johns': 'CAD',
    'America/Regina': 'CAD',      'America/Edmonton': 'CAD'
  };

  // Fallback rates (GTQ as base, approximate for 2025)
  var FALLBACK = {
    GTQ: 1, USD: 0.129, MXN: 2.15, EUR: 0.119, HNL: 3.21,
    BZD: 0.26, CRC: 66.8, CAD: 0.177, GBP: 0.102
  };

  var S = {
    currency: 'GTQ',
    rates: Object.assign ? Object.assign({}, FALLBACK) : FALLBACK
  };

  // ── Detect ────────────────────────────────────────────────────────
  function detect() {
    var saved = localStorage.getItem('sr_currency');
    if (saved && SYMBOLS[saved]) return saved;
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return TZ_MAP[tz] || 'GTQ';
    } catch (e) { return 'GTQ'; }
  }

  // ── Rates ─────────────────────────────────────────────────────────
  function loadRates() {
    var raw = localStorage.getItem('sr_fx_rates');
    var ts  = parseInt(localStorage.getItem('sr_fx_ts') || '0', 10);
    if (raw && (Date.now() - ts) < 3600000) {
      try { S.rates = JSON.parse(raw); return Promise.resolve(); } catch (e) {}
    }
    return fetch('https://open.er-api.com/v6/latest/GTQ')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.rates) {
          S.rates = d.rates;
          localStorage.setItem('sr_fx_rates', JSON.stringify(d.rates));
          localStorage.setItem('sr_fx_ts', Date.now().toString());
        }
      })
      .catch(function () { S.rates = FALLBACK; });
  }

  // ── Format ────────────────────────────────────────────────────────
  function fmt(gtqAmount, code) {
    var rate = (S.rates[code] !== undefined) ? S.rates[code] : (FALLBACK[code] || 1);
    var amount = gtqAmount * rate;
    var sym = SYMBOLS[code] || code;
    var decimals = 2;
    if (code === 'CRC') decimals = 0;
    if (code === 'HNL') decimals = 0;
    var str = amount.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sym + ' ' + str;
  }

  // ── Convert DOM ───────────────────────────────────────────────────
  function fmtRound(gtqAmount, code) {
    var rate = (S.rates[code] !== undefined) ? S.rates[code] : (FALLBACK[code] || 1);
    var amount = Math.round(gtqAmount * rate);
    var sym = SYMBOLS[code] || code;
    return sym + ' ' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function convertAll() {
    var cur = S.currency;
    document.querySelectorAll('[data-cents]').forEach(function (el) {
      var c = parseInt(el.getAttribute('data-cents'), 10);
      if (!isNaN(c)) el.textContent = fmt(c / 100, cur);
    });
    document.querySelectorAll('[data-gtq]').forEach(function (el) {
      var g = parseFloat(el.getAttribute('data-gtq'));
      if (!isNaN(g)) {
        el.textContent = el.hasAttribute('data-round') ? fmtRound(g, cur) : fmt(g, cur);
      }
    });
  }

  // ── Set ───────────────────────────────────────────────────────────
  function set(code) {
    if (!SYMBOLS[code]) return;
    S.currency = code;
    localStorage.setItem('sr_currency', code);
    convertAll();
    syncUI();
  }

  // ── Selector UI ───────────────────────────────────────────────────
  function buildSelector() {
    var wrap = document.getElementById('sr-currency-selector');
    if (!wrap) return;

    var rows = SUPPORTED.map(function (code) {
      return '<li class="sr-cur-opt' + (code === S.currency ? ' is-active' : '') +
        '" role="option" data-code="' + code +
        '" aria-selected="' + (code === S.currency) + '">' +
        '<span class="sr-cur-sym">' + SYMBOLS[code] + '</span>' +
        '<span class="sr-cur-info">' +
          '<span class="sr-cur-code">' + code + '</span>' +
          '<span class="sr-cur-name">' + NAMES[code] + '</span>' +
        '</span>' +
        '</li>';
    }).join('');

    wrap.innerHTML =
      '<button class="sr-cur-trigger" id="sr-cur-btn" aria-haspopup="listbox" aria-expanded="false" aria-label="Cambiar moneda">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
          '<circle cx="12" cy="12" r="10"/>' +
          '<path d="M2 12h20M12 2a15 15 0 010 20M12 2a15 15 0 000 20"/>' +
        '</svg>' +
        '<span id="sr-cur-lbl">' + S.currency + '</span>' +
        '<svg class="sr-cur-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>' +
      '</button>' +
      '<ul class="sr-cur-list" id="sr-cur-list" role="listbox" hidden>' + rows + '</ul>';

    var btn  = document.getElementById('sr-cur-btn');
    var list = document.getElementById('sr-cur-list');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !list.hidden;
      list.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
    });

    list.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-code]');
      if (!opt) return;
      set(opt.getAttribute('data-code'));
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('click', function () {
      if (list && !list.hidden) {
        list.hidden = true;
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function syncUI() {
    var lbl = document.getElementById('sr-cur-lbl');
    if (lbl) lbl.textContent = S.currency;
    document.querySelectorAll('.sr-cur-opt').forEach(function (opt) {
      var active = opt.getAttribute('data-code') === S.currency;
      opt.classList.toggle('is-active', active);
      opt.setAttribute('aria-selected', String(active));
    });
  }

  // ── MutationObserver (cart drawer items, dynamic prices) ─────────
  // Disconnect before convertAll() so its own DOM mutations don't re-trigger the observer
  function observe() {
    if (!window.MutationObserver) return;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        mo.disconnect();
        convertAll();
        pending = false;
        mo.observe(document.body, { childList: true, subtree: true });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // ── CSS ───────────────────────────────────────────────────────────
  function injectCSS() {
    var s = document.createElement('style');
    s.textContent = [
      '#sr-currency-selector { position:relative; display:inline-flex; }',
      '.sr-cur-trigger { display:inline-flex; align-items:center; gap:5px; padding:5px 10px;',
        'background:transparent; border:1px solid rgba(255,255,255,.25); border-radius:20px;',
        'color:inherit; font-size:.75rem; font-weight:600; letter-spacing:.04em; cursor:pointer;',
        'transition:border-color .2s, background .2s; white-space:nowrap; }',
      '.sr-cur-trigger:hover { border-color:var(--gold,#D4A017); background:rgba(255,255,255,.05); }',
      '.sr-cur-chevron { margin-left:1px; transition:transform .2s; }',
      '.sr-cur-trigger[aria-expanded="true"] .sr-cur-chevron { transform:rotate(180deg); }',
      '.sr-cur-list { position:absolute; top:calc(100% + 8px); right:0; min-width:210px;',
        'background:#1a1a1a; border:1px solid rgba(255,255,255,.12); border-radius:10px;',
        'padding:6px; z-index:9999; list-style:none; box-shadow:0 8px 32px rgba(0,0,0,.5); }',
      '.sr-cur-opt { display:flex; align-items:center; gap:10px; padding:8px 10px;',
        'border-radius:6px; cursor:pointer; transition:background .15s; }',
      '.sr-cur-opt:hover { background:rgba(255,255,255,.08); }',
      '.sr-cur-opt.is-active { background:rgba(212,160,23,.15); }',
      '.sr-cur-opt.is-active .sr-cur-code { color:var(--gold,#D4A017); }',
      '.sr-cur-sym { width:28px; text-align:center; font-weight:700; font-size:.8rem;',
        'color:var(--gold,#D4A017); flex-shrink:0; }',
      '.sr-cur-info { display:flex; flex-direction:column; }',
      '.sr-cur-code { font-size:.75rem; font-weight:700; color:#fff; line-height:1.2; }',
      '.sr-cur-name { font-size:.65rem; color:rgba(255,255,255,.5); line-height:1.2; }',
      // Note for pages where we can't change actual checkout currency
      '.sr-cur-note { font-size:.65rem; color:rgba(255,255,255,.4); text-align:center;',
        'padding:6px 10px 2px; border-top:1px solid rgba(255,255,255,.08); margin-top:4px; }'
    ].join('');
    document.head.appendChild(s);
  }

  // ── Init ──────────────────────────────────────────────────────────
  function init() {
    injectCSS();
    S.currency = detect();
    buildSelector();

    loadRates().then(function () {
      convertAll();
      observe();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API
  window.srCurrency = {
    set: set,
    convert: convertAll,
    fmt: fmt,
    current: function () { return S.currency; }
  };
})();
